import { Component, OnInit, ViewChild } from '@angular/core';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IBreadcrumbItems } from '@coreui/angular/lib/breadcrumb/breadcrumb';
import { UserTranslationService } from '../../../services/user-translation/user-translation.service';
import { ToolService } from '../../../services/tool/tool.service';
import { NotificationsComponent } from '../../../views/notifications/notifications.component';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit {

  breadcrumbs: Array<IBreadcrumbItems> = [];
  isFirstLoaded: boolean = false;
  @ViewChild(NotificationsComponent) notificationsComponent!: NotificationsComponent;

  constructor(
    private classToggler: ClassToggleService,
    private router: Router,
    private storageSrv: StorageService,
    private localInterfaceSrv: LocalInterfaceService,
    private activatedRoute: ActivatedRoute,
    private userTranslationService: UserTranslationService,
    public toolService: ToolService,
  ) {
    super();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
          this.isFirstLoaded = true;
        }, this.isFirstLoaded ? 0 : 300);
      });
  }

  public facilityId = this.storageSrv.getFacilityId();
  public ownerId = this.storageSrv.getOwner();
  public token = this.storageSrv.getToken();
  public facilityList?;
  public userName = this.storageSrv.getUserName();

  ngOnInit(): void {
    this.toggleTheme();
    this.loadFacilities();
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Array<any> = []): Array<any> {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) { return breadcrumbs };
    for (const child of children) {
      const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      } else {
        url = '/';
      };
      breadcrumbs.push({ label: this.getRouteLabel(child), url });
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }

  private getRouteLabel(route: ActivatedRoute): string {
    const routeData = route.snapshot.data;
    return (routeData && routeData.title) ? this.userTranslationService.translateText('AppRouteTitles.' + routeData.title) : '';
  }


  toggleTheme() {
    this.classToggler.toggle('.c-app', 'c-dark-theme');
  }

  loadFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getFacilitiesList(null)
        .then(res => {
          this.facilityList = res;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err);
        })
        .finally(
          () => { }
        );
    });
  }

  changeFacility = async () => {
    this.facilityList.content.forEach(facility => {
      if (facility.id == this.facilityId) {
        this.changeOwnerFacility(this.token, facility.id);
        // if (this.notificationsComponent) {
        //   this.notificationsComponent.getFacilityActivities();
        // }
      }
    });
    // this.goToDashboard();    
  }


  goToDashboard = () => {

    if (this.router.url == '/dashboard') {
      this.router.navigate(['/calendar']);
    }
    else {
      this.router.navigate(['/dashboard']);
    }
  }

  goToCalendar = () => {

    if (this.router.url == '/calendar') {
      this.router.navigate(['/booking']);
    }
    else {
      this.router.navigate(['/calendar']);
    }
  }

  signOut = () => {
    this.storageSrv.signOut();
  }

  changeOwnerFacility = async (token, facilityId) => {
    this.localInterfaceSrv.changeOwnerFacility(token, facilityId)
      .then(res => {
        if (res.content[0].isStaff == 1) {
          this.goToCalendar();
        }
        else if (res.content[0].type == 'coach') {
          this.goToCalendar();
        }
        else if (res.content[0].type == 'owner') {
          this.goToDashboard();
        }
        else if (res.content[0].type == 'admin') {
          this.goToDashboard();
        }
        else if (res.content[0].type == 'user') {
          this.signOut();
        }
      })
      .catch()
      .finally();
  }

}
